module.exports = __webpack_public_path__ + "coin_DASHG.png?ddece040005c1c166ef8cb450e37ca45";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/coin_DASHG.png
// module id = 1122
// module chunks = 2